const STORAGE_PREFIX = 'pokerTimer_';

/**
 * Zapisuje dane do localStorage
 * @param {string} key - Klucz do zapisania
 * @param {any} value - Wartość do zapisania
 */
export const saveToStorage = (key, value) => {
    try {
        const serializedValue = JSON.stringify(value);
        localStorage.setItem(`${STORAGE_PREFIX}${key}`, serializedValue);
    } catch (error) {
        console.error('Error saving to localStorage:', error);
    }
};

/**
 * Pobiera dane z localStorage
 * @param {string} key - Klucz do odczytania
 * @param {any} defaultValue - Wartość domyślna, jeśli klucz nie istnieje
 * @returns {any} - Odczytana wartość lub wartość domyślna
 */
export const getFromStorage = (key, defaultValue = null) => {
    try {
        const serializedValue = localStorage.getItem(`${STORAGE_PREFIX}${key}`);
        if (serializedValue === null) {
            return defaultValue;
        }
        return JSON.parse(serializedValue);
    } catch (error) {
        console.error('Error reading from localStorage:', error);
        return defaultValue;
    }
};

/**
 * Usuwa dane z localStorage
 * @param {string} key - Klucz do usunięcia
 */
export const removeFromStorage = (key) => {
    try {
        localStorage.removeItem(`${STORAGE_PREFIX}${key}`);
    } catch (error) {
        console.error('Error removing from localStorage:', error);
    }
};

/**
 * Czyści wszystkie dane aplikacji z localStorage
 */
export const clearStorage = () => {
    try {
        Object.keys(localStorage)
            .filter(key => key.startsWith(STORAGE_PREFIX))
            .forEach(key => localStorage.removeItem(key));
    } catch (error) {
        console.error('Error clearing localStorage:', error);
    }
};